import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {  Cookies } from 'react-cookie';
import ChangeRequestFinancialPayChecked from './ChangeRequestFinancialPayChecked';
import ChangeRequestFinancialPayDocProgress from './ChangeRequestFinancialPayDocProgress';
import ChangeRequestFinancialPayed from './ChangeRequestFinancialPayed';
import ChangeRequestFinancialPayDocNotPay from './ChangeRequestFinancialPayDocNotPay';
import ChangeRequestFinancialDocPayed from './ChangeRequestFinancialDocPayed';




const styles = theme => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
  , paper: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(20),
      },
    },


});

class ChangeRequestFinancialPay extends Component {
  cookies=new Cookies();
  constructor(props) {
      super(props);
    this.state = {
  value:0,
}}

componentDidMount() {

}
handleChange= (event,newValue) => {
  this.setState({ value:newValue });
}
    render() {
      const { classes } = this.props;
      const { value } = this.state;

        return (
            <div style={{dir:'rtl',direction: 'rtl'}}>
                 <AppBar style={{dir:'rtl'}} position="sticky"color="primary" >

                   <Tabs
                    style={{height:'60px',textAlign:'center',dir:'rtl'}}
                     value={value}
                     onChange={this.handleChange}
                     indicatorColor="secondary"
                     textColor={'#000000'}
                     variant="scrollable"
                     scrollButtons="on"
                               aria-label="scrollable force tabs example"
                   >
                     <Tab label="درخواست های بررسی شده"  />
                     <Tab label="درخواست های  سند خورده درحال پرداخت"  />
                     <Tab label="سند های پرداخت نشده"  />
                     <Tab label="درخواست های  سند خورده و پرداخت شده"  />
                     <Tab label="سند های پرداخت شده"  />

                     </Tabs>


                 </AppBar>
                 {(value==0)?<ChangeRequestFinancialPayChecked  props={this.props}/>:null}
                 {(value==1)?<ChangeRequestFinancialPayDocProgress  props={this.props}/>:null}
                 {(value==2)?<ChangeRequestFinancialPayDocNotPay  props={this.props}/>:null}
                 {(value==3)?<ChangeRequestFinancialPayed  props={this.props}/>:null}
                 {(value==4)?<ChangeRequestFinancialDocPayed  props={this.props}/>:null}


               </div>
        );
    }
}

export default  withStyles(styles)(ChangeRequestFinancialPay);
